export class UserPermission {
  userPermissionId?: number;
  userId?: number;
  permissionType: string;
  value?: string;
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string;
}


export class Permissions {

  public static allPermissionTypes = {
    basicSiteOperations: "basicSiteOperations",
    readBasicSiteData: "readBasicSiteData",

    searchData: "searchData",
    downloadData: "downloadData",
    accessRestrictedImages: "accessRestrictedImages",
    accessImages: "accessImages",
    viewPatients: "viewPatients",
    viewPatientData: "viewPatientData",
    managePedigree: "managePedigree",

    manageDataNotes: "manageDataNotes",
    manageImagePackages: "manageImagePackages",
    managePendingApprovals: "managePendingApprovals",

    accessReportBuilder: "accessReportBuilder",
    accessQcReports: "accessQcReports",
    accessGradingReports: "accessGradingReports",
    accessResearcherReports: "accessResearcherReports",

    manageTags: "manageTags",
    useTags: "useTags",

    adjudicate: "adjudicate",
    uploadData: "uploadData",

    gradeImages: "gradeImages",
    dataLock: "dataLock",
    srGrader: "srGrader",
    clinicianReview: "clinicianReview",

    manageUsers: "manageUsers",
    deleteData: "deleteData"
  }

  // auto granted permissions per role
  public static adminAutoPermissions = [
    Permissions.allPermissionTypes.readBasicSiteData,
    Permissions.allPermissionTypes.basicSiteOperations,
    Permissions.allPermissionTypes.adjudicate,
    Permissions.allPermissionTypes.manageUsers,
    Permissions.allPermissionTypes.viewPatientData,
    Permissions.allPermissionTypes.viewPatients,
    Permissions.allPermissionTypes.downloadData,
    Permissions.allPermissionTypes.manageDataNotes,
    Permissions.allPermissionTypes.deleteData,
    Permissions.allPermissionTypes.gradeImages,
    Permissions.allPermissionTypes.managePedigree,
    Permissions.allPermissionTypes.manageImagePackages,
    Permissions.allPermissionTypes.manageTags,
    Permissions.allPermissionTypes.useTags,
    Permissions.allPermissionTypes.searchData,
    Permissions.allPermissionTypes.accessQcReports,
    Permissions.allPermissionTypes.accessGradingReports,
    Permissions.allPermissionTypes.accessResearcherReports,
    Permissions.allPermissionTypes.accessReportBuilder,
    Permissions.allPermissionTypes.managePendingApprovals,
    Permissions.allPermissionTypes.dataLock,
    Permissions.allPermissionTypes.srGrader,
    Permissions.allPermissionTypes.clinicianReview,
    Permissions.allPermissionTypes.uploadData,
  ];
  public static graderAutoPermissions = [
    Permissions.allPermissionTypes.readBasicSiteData,
    Permissions.allPermissionTypes.basicSiteOperations,
    Permissions.allPermissionTypes.adjudicate,
    Permissions.allPermissionTypes.viewPatientData,
    Permissions.allPermissionTypes.gradeImages,
    Permissions.allPermissionTypes.manageImagePackages,
    Permissions.allPermissionTypes.accessGradingReports,
    Permissions.allPermissionTypes.accessQcReports
  ];
  public static qcAutoPermissions = [
    Permissions.allPermissionTypes.readBasicSiteData,
    Permissions.allPermissionTypes.basicSiteOperations,
    Permissions.allPermissionTypes.adjudicate,
    Permissions.allPermissionTypes.viewPatientData,
    Permissions.allPermissionTypes.manageDataNotes,
    Permissions.allPermissionTypes.manageImagePackages,
    Permissions.allPermissionTypes.accessQcReports,
  ];
  public static researcherAutoPermissions = [
    Permissions.allPermissionTypes.readBasicSiteData,
    Permissions.allPermissionTypes.basicSiteOperations,
    Permissions.allPermissionTypes.viewPatientData,
    Permissions.allPermissionTypes.manageDataNotes,
    Permissions.allPermissionTypes.managePedigree,
    Permissions.allPermissionTypes.useTags,
    Permissions.allPermissionTypes.searchData,
    Permissions.allPermissionTypes.accessResearcherReports,
  ];
  public static technicianAutoPermissions = [
    Permissions.allPermissionTypes.readBasicSiteData,
    Permissions.allPermissionTypes.basicSiteOperations,
    Permissions.allPermissionTypes.uploadData,
  ];

  // assignable permissions, extra permissions each role can get

  public static researcherPermissions = {
    downloadData: "downloadData",
    accessImages: "accessImages",
    accessReportBuilder: "accessReportBuilder",
  }

  public static graderPermissions = {
    accessImages: "accessImages",
    viewPatients: "viewPatients",
    viewPatientData: "viewPatientData",
    managePendingApprovals: "managePendingApprovals",
    uploadData: "uploadData",
    dataLock: "dataLock",
    srGrader: "srGrader",
    clinicianReview: "clinicianReview",
    accessReportBuilder: "accessReportBuilder",
    adjudicate: "adjudicate"
  }
}


// WEBPACK FOOTER //
// ./src/app/models/user-permission.model.ts